// cleanup_convert_to_typescript_file_GENERICS

export const ACTIONS = {
  SET_ERROR_MESSAGE: 'setErrorMessage',
  HANDLE_DEFAULTS: 'handleDefaults',
  UPDATE_WIDGETS: 'updateWidgets',
  SHOW_PASSWORD_EXPIRATION_ALERT: 'showPasswordExpirationAlert'
};

const reducer = (state, { payload, type }) => {
  switch (type) {
    case ACTIONS.SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: payload
      };
    case ACTIONS.HANDLE_DEFAULTS:
      return {
        ...state,
        lockedDefaults: payload.lockedDefaults,
        allowedWidgets: payload.allowedWidgets,
        unlockedDefaults: payload.unlockedDefaults
      };
    case ACTIONS.UPDATE_WIDGETS:
      return {
        ...state,
        lockedDefaults: payload.lockedDefaults,
        unlockedDefaults: payload.unlockedDefaults
      };
    case ACTIONS.SHOW_PASSWORD_EXPIRATION_ALERT:
      return {
        ...state,
        showPasswordExpirationAlert: payload
      };
    default:
      return state;
  }
};

export default reducer;
